(() => {
  const setup = () => {
    const footer = document.querySelector('footer.footer');
    if (!footer || !document.querySelector('.product-mini-checkout') || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      document.body.classList.toggle('zt-footer-visible', entries[0].isIntersecting);
    });
    observer.observe(footer);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
